import { SERVER_URL } from "./config";

const groupNames = ["group-1", "group-2"];

function formatDate(date) {
  var d = new Date(date),
    month = "" + (d.getMonth() + 1),
    day = "" + d.getDate(),
    year = d.getFullYear();

  if (month.length < 2) month = "0" + month;
  if (day.length < 2) day = "0" + day;

  return [year, month, day].join("-");
}

const arbudaGroupInfo = {
  "group-1": [
    {
      label: "Vehicle No",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "vehicle_no",
      placeHolder: "1234",
      type: "text",
      keyboardNavigationMap: {
        Enter: "delivery_dest_type",
      },
      apiConfigKey: "getVehicleSuggestions",
      url: SERVER_URL + "/vehicle/",
      suggestionKeyword: "vehicle_no",
      suggestionKeywordForFetchApiArgs: "vehicle_no",
      suggestionChooseQueryKeyword: "vehicle_no",
      apiCallRequiredOnGetValue: true,
      toValidate: true,
      suggestionSchema: {
        vehicle_no: "vehicle_no",
        vehicle_id: "vehicle_id",
        owner_name: "driver_name",
      },
      keyboardNavigationMap: {
        Enter: "driver_name",
      },
    },
    {
      label: "Driver Name",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "driver_name",
      type: "text",
      placeHolder: "",
      // url: SERVER_URL + "/branch/",
      suggestionKeyword: "name",
      // suggestionSchema: {
      //   vehicle_id: "vehicle_id",
      //   vehicle_no: "vehicle_no",
      //   driver_name: "driver_name",
      //   owner_name: "owner_name",
      // },
      toValidate: true,
      regExpValidation: "[a-zA-z]",
      keyboardNavigationMap: {
        Enter: "station_name",
      },
    },
    {
      label: "Station To",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "station_name",
      type: "text",
      placeHolder: "",
      apiConfigKey: "getCitySuggestions",
      url: SERVER_URL + "/branch/",
      suggestionKeyword: "name",
      suggestionKeywordForFetchApiArgs: "name",
      suggestionSchema: {
        branch_id: "station_from",
        name: "station_from_name",
      },
      toValidate: true,
      regExpValidation: "[a-zA-z]",
      apiCallRequiredOnGetValue: true,
      suggestionChooseQueryKeyword: "branch_id",
      keyboardNavigationMap: {
        Enter: "lorry_hire",
      },
    },
    {
      label: "Lorry Hire",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "lorry_hire",
      type: "text",
      placeHolder: "",
      toValidate: false,
      regExpValidation: "[a-zA-z]",
      keyboardNavigationMap: {
        Enter: "remarks",
      },
    },
  ],
  "group-2": [
    // {
    //   label: "Party Name",
    //   className: "form-row",
    //   labelClassName: "form-label",
    //   inputClassName: "form-input",
    //   name: "party_name",
    //   type: "text",
    //   placeHolder: "",
    //   // url: SERVER_URL + "/branch/",
    //   suggestionKeyword: "name",
    //   // suggestionSchema: {
    //   //   vehicle_id: "vehicle_id",
    //   //   vehicle_no: "vehicle_no",
    //   //   driver_name: "driver_name",
    //   //   owner_name: "owner_name",
    //   // },
    //   toValidate: false,
    //   regExpValidation: "[a-zA-z]",
    //   keyboardNavigationMap: {
    //     Enter: "remarks",
    //   },
    // },
    {
      label: "Remarks",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "remarks",
      type: "text",
      placeHolder: "",
      keyboardNavigationMap: {
        Enter: "pkgs",
      },
    },
    {
      label: "Packages",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "pkgs",
      type: "text",
      placeHolder: "",
      toValidate: false,
      regExpValidation: "^(?:[0-9]+d*|d)$",
      keyboardNavigationMap: {
        Enter: "cewb_no",
      },
    },
    // {
    //   label: "Tempo Collection",
    //   className: "form-row",
    //   labelClassName: "form-label",
    //   inputClassName: "form-input",
    //   name: "total_tempo_collection",
    //   type: "text",
    //   placeHolder: "",
    //   toValidate: false,
    //   regExpValidation: "^(?:[0-9]+d*|d)$",
    //   keyboardNavigationMap: {
    //     Enter: "print_button",
    //   },
    // },
    {
      label: "CWB No",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "cewb_no",
      type: "text",
      placeHolder: "",
    },
    {
      label: "Total EWay",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "total_cewb",
      type: "text",
      placeHolder: "",
    },
    // {
    //   label: "Silak",
    //   className: "form-row",
    //   labelClassName: "form-label",
    //   inputClassName: "form-input",
    //   name: "silak",
    //   type: "text",
    //   placeHolder: "",
    //   // apiConfigKey: "getCitySuggestions",
    //   // url: SERVER_URL + "/branch/",
    //   // suggestionKeyword: "name",
    //   // suggestionKeywordForFetchApiArgs: "name",
    //   // suggestionSchema: {
    //   //   branch_id: "payable_branch",
    //   //   name: "payable_branch_name",
    //   // },
    //   // toValidate: true,
    //   // regExpValidation: "[a-zA-z]",
    //   apiCallRequiredOnGetValue: true,
    //   suggestionChooseQueryKeyword: "branch_id",
    //   keyboardNavigationMap: {
    //     Enter: "left_pkgs",
    //   },
    // },
    // {
    //   label: "Total Packages",
    //   className: "form-row",
    //   labelClassName: "form-label",
    //   inputClassName: "form-input",
    //   name: "total_pkgs",
    //   type: "text",
    //   placeHolder: "",
    //   toValidate: false,
    //   regExpValidation: "^(?:[0-9]+d*|d)$",
    //   keyboardNavigationMap: {
    //     Enter: "left_pkgs",
    //   },
    // },
    // {
    //   label: "Left Packages",
    //   className: "form-row",
    //   labelClassName: "form-label",
    //   inputClassName: "form-input",
    //   name: "left_pkgs",
    //   type: "text",
    //   placeHolder: "",
    //   toValidate: false,
    //   regExpValidation: "^(?:[0-9]+d*|d)$",
    //   keyboardNavigationMap: {
    //     Enter: "print_button",
    //   },
    // },
  ],
};

const defaultGroupInfo = {
  "group-1": [
    {
      label: "Vehicle No",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "vehicle_no",
      placeHolder: "1234",
      type: "text",
      keyboardNavigationMap: {
        Enter: "delivery_dest_type",
      },
      apiConfigKey: "getVehicleSuggestions",
      url: SERVER_URL + "/vehicle/",
      suggestionKeyword: "vehicle_no",
      suggestionKeywordForFetchApiArgs: "vehicle_no",
      suggestionChooseQueryKeyword: "vehicle_no",
      apiCallRequiredOnGetValue: true,
      toValidate: true,
      suggestionSchema: {
        vehicle_no: "vehicle_no",
        vehicle_id: "vehicle_id",
        owner_name: "driver_name",
      },
      keyboardNavigationMap: {
        Enter: "driver_name",
      },
    },
    {
      label: "Driver Name",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "driver_name",
      type: "text",
      placeHolder: "",
      // url: SERVER_URL + "/branch/",
      suggestionKeyword: "name",
      // suggestionSchema: {
      //   vehicle_id: "vehicle_id",
      //   vehicle_no: "vehicle_no",
      //   driver_name: "driver_name",
      //   owner_name: "owner_name",
      // },
      toValidate: true,
      regExpValidation: "[a-zA-z]",
      keyboardNavigationMap: {
        Enter: "station_name",
      },
    },
    {
      label: "Station To",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "station_name",
      type: "text",
      placeHolder: "",
      apiConfigKey: "getCitySuggestions",
      url: SERVER_URL + "/branch/",
      suggestionKeyword: "name",
      suggestionKeywordForFetchApiArgs: "name",
      suggestionSchema: {
        branch_id: "station_from",
        name: "station_from_name",
      },
      toValidate: true,
      regExpValidation: "[a-zA-z]",
      apiCallRequiredOnGetValue: true,
      suggestionChooseQueryKeyword: "branch_id",
      keyboardNavigationMap: {
        Enter: "remarks",
      },
    },
    // {
    //   label: "Amount",
    //   className: "form-row",
    //   labelClassName: "form-label",
    //   inputClassName: "form-input",
    //   name: "amount",
    //   type: "text",
    //   placeHolder: "",
    //   toValidate: false,
    //   regExpValidation: "[a-zA-z]",
    //   keyboardNavigationMap: {
    //     Enter: "pkgs",
    //   },
    // },
  ],
  "group-2": [
    // {
    //   label: "Party Name",
    //   className: "form-row",
    //   labelClassName: "form-label",
    //   inputClassName: "form-input",
    //   name: "party_name",
    //   type: "text",
    //   placeHolder: "",
    //   // url: SERVER_URL + "/branch/",
    //   suggestionKeyword: "name",
    //   // suggestionSchema: {
    //   //   vehicle_id: "vehicle_id",
    //   //   vehicle_no: "vehicle_no",
    //   //   driver_name: "driver_name",
    //   //   owner_name: "owner_name",
    //   // },
    //   toValidate: false,
    //   regExpValidation: "[a-zA-z]",
    //   keyboardNavigationMap: {
    //     Enter: "remarks",
    //   },
    // },
    {
      label: "Remarks",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "remarks",
      type: "text",
      placeHolder: "",
      keyboardNavigationMap: {
        Enter: "pkgs",
      },
    },
    {
      label: "Packages",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "pkgs",
      type: "text",
      placeHolder: "",
      toValidate: false,
      regExpValidation: "^(?:[0-9]+d*|d)$",
      keyboardNavigationMap: {
        Enter: "total_tempo_collection",
      },
    },
    {
      label: "Tempo Collection",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "total_tempo_collection",
      type: "text",
      placeHolder: "",
      toValidate: false,
      regExpValidation: "^(?:[0-9]+d*|d)$",
      keyboardNavigationMap: {
        Enter: "print_button",
      },
    },
    {
      label: "CWB No",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "cewb_no",
      type: "text",
      placeHolder: "",
    },
    {
      label: "Total EWay",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "total_cewb",
      type: "text",
      placeHolder: "",
    },
    // {
    //   label: "Silak",
    //   className: "form-row",
    //   labelClassName: "form-label",
    //   inputClassName: "form-input",
    //   name: "silak",
    //   type: "text",
    //   placeHolder: "",
    //   // apiConfigKey: "getCitySuggestions",
    //   // url: SERVER_URL + "/branch/",
    //   // suggestionKeyword: "name",
    //   // suggestionKeywordForFetchApiArgs: "name",
    //   // suggestionSchema: {
    //   //   branch_id: "payable_branch",
    //   //   name: "payable_branch_name",
    //   // },
    //   // toValidate: true,
    //   // regExpValidation: "[a-zA-z]",
    //   apiCallRequiredOnGetValue: true,
    //   suggestionChooseQueryKeyword: "branch_id",
    //   keyboardNavigationMap: {
    //     Enter: "left_pkgs",
    //   },
    // },
    // {
    //   label: "Total Packages",
    //   className: "form-row",
    //   labelClassName: "form-label",
    //   inputClassName: "form-input",
    //   name: "total_pkgs",
    //   type: "text",
    //   placeHolder: "",
    //   toValidate: false,
    //   regExpValidation: "^(?:[0-9]+d*|d)$",
    //   keyboardNavigationMap: {
    //     Enter: "left_pkgs",
    //   },
    // },
    // {
    //   label: "Left Packages",
    //   className: "form-row",
    //   labelClassName: "form-label",
    //   inputClassName: "form-input",
    //   name: "left_pkgs",
    //   type: "text",
    //   placeHolder: "",
    //   toValidate: false,
    //   regExpValidation: "^(?:[0-9]+d*|d)$",
    //   keyboardNavigationMap: {
    //     Enter: "print_button",
    //   },
    // },
  ],
};

const arbudaDataObject = {
  mf_id: "",
  mf_no: "",
  driver_name: "",
  vehicle_no: "",
  vehicle_id: "",
  station_name: "",
  // station_from: "",
  // mf_date: formatDate(new Date()),
  // mf_date: new Date().toISOString(),
  mf_date: new Date(),
  pkgs: "",
  party_name: "",
  amount: "",
  remarks: "",
  silak: "",
  left_pkgs: "",
  bilty_ids: [],
  total_pkgs: "",
  created_by: "",
  created_from: "",
  last_mf_no: "",
  total_cewb: "",
  is_deleted: 0,
  suffix: "",
  suffix_options: [],
  bilty_no: "",
  packages: "",
  // actual_packages: "",
  bilty_info: [],
  cewb_no: "",
  // total_tempo_collection: "",
  status: "",
  lorry_hire: "",
};

const defaultDataObject = {
  mf_id: "",
  mf_no: "",
  driver_name: "",
  vehicle_no: "",
  vehicle_id: "",
  station_name: "",
  // station_from: "",
  // mf_date: formatDate(new Date()),
  // mf_date: new Date().toISOString(),
  mf_date: new Date(),
  pkgs: "",
  party_name: "",
  amount: "",
  remarks: "",
  silak: "",
  left_pkgs: "",
  bilty_ids: [],
  total_pkgs: "",
  created_by: "",
  created_from: "",
  last_mf_no: "",
  total_cewb: "",
  is_deleted: 0,
  suffix: "",
  suffix_options: [],
  bilty_no: "",
  packages: "",
  // actual_packages: "",
  bilty_info: [],
  cewb_no: "",
  total_tempo_collection: "",
  status: "",
};

const getGroupInfoBasedOnClient = () => {

  const clientGroupMap = {
    arbuda: arbudaGroupInfo,
  };

  return clientGroupMap[process.env.REACT_APP_CLIENT] || defaultGroupInfo
};

var groupInfo = getGroupInfoBasedOnClient();


const getDataObjectBasedOnClient = ()=> {
  const clientGroupMap = {
    arbuda: arbudaDataObject
  }

  return clientGroupMap[process.env.REACT_APP_CLIENT] || defaultDataObject
}

var dataObject = getDataObjectBasedOnClient()

const arbudaChallanBiltyOriginalTableHeader = [
  { label: "S. No.", className: "text-center table-header" },
  { label: "Bilty No.", className: "text-center table-header" },
  { label: "Ref No.", className: "text-center table-header" },
  // { label: "MF No.", className: "text-center table-header" },
  { label: "Bilty Date", className: "text-center table-header" },
  { label: "Station From", className: "text-center table-header" },
  { label: "Station To", className: "text-center table-header" },
  { label: "Pay Type", className: "text-center table-header" },
  { label: "Consignor Name", className: "text-center table-header" },
  { label: "Consignee Name", className: "text-center table-header" },
  { label: "No Of Package", className: "text-center table-header" },
  { label: "Charge Weight", className: "text-center table-header" },
  { label: "Total Amount", className: "text-center table-header" },
  // { label: "Delivery Status", className: "text-center table-header" },
  // { label: "Tempo Collection", className: "text-center table-header" },
];

const defaultChallanBiltyOriginalTableHeader = [
  { label: "S. No.", className: "text-center table-header" },
  { label: "Bilty No.", className: "text-center table-header" },
  { label: "Ref No.", className: "text-center table-header" },
  // { label: "MF No.", className: "text-center table-header" },
  { label: "Bilty Date", className: "text-center table-header" },
  { label: "Station From", className: "text-center table-header" },
  { label: "Station To", className: "text-center table-header" },
  { label: "Pay Type", className: "text-center table-header" },
  { label: "Consignor Name", className: "text-center table-header" },
  { label: "Consignee Name", className: "text-center table-header" },
  { label: "No Of Package", className: "text-center table-header" },
  { label: "Charge Weight", className: "text-center table-header" },
  { label: "Total Amount", className: "text-center table-header" },
  { label: "Delivery Status", className: "text-center table-header" },
  { label: "Tempo Collection", className: "text-center table-header" },
];

const arbudaChallanBiltyOriginalTableItems = [
  {
    type: "text",
    name: "bilty_no",
    label: "Bilty No",
    className: "form-control-medium-col",
  },
  {
    type: "text",
    name: "reference_no",
    label: "Bilty No",
    className: "form-control-medium-col",
  },
  // {
  //   type: "text",
  //   name: "mf_no",
  //   label: "Bilty No",
  //   className: "form-control-medium-col",
  // },
  {
    type: "text",
    name: "bilty_date",
    label: "Bilty Date",
    className: "form-control-medium-col",
    convertFunction: (itemObject) => {
      return formatDate(itemObject.bilty_date);
    },
  },
  {
    type: "text",
    name: "station_from",
    label: "Station From",
    className: "form-control-medlarge-col",
  },
  {
    type: "text",
    name: "station_to",
    label: "Station To",
    className: "form-control-medlarge-col",
  },
  {
    type: "text",
    name: "pay_type_name",
    label: "Pay Type",
    className: "form-control-medium-col",
  },
  {
    type: "text",
    name: "consignor_name",
    label: "Consignor Name",
    className: "form-control-large-col",
  },
  {
    type: "text",
    name: "consignee_name",
    label: "Consignee Name",
    className: "form-control-large-col",
  },
  {
    type: "text",
    name: "no_of_package",
    label: "No Of Package",
    className: "form-control-small-col",
  },
  {
    type: "text",
    name: "charge_weight",
    label: "Charge Weight",
    className: "form-control-small-col",
  },
  {
    type: "text",
    name: "total_amount",
    label: "Charge Weight",
    className: "form-control-small-col",

    // convertFunction: (itemObject) => {
    //   let roleId = 0;

    //   try {
    //     roleId = Number(
    //       JSON.parse(sessionStorage.getItem("role_id"))?.role_id || 0
    //     );
    //   } catch (e) {
    //     roleId = 0;
    //   }

    //   const payType = Number(itemObject?.pay_type);

    //   const isAdmin = roleId === 1 || roleId === 2;
    //   const isToPay = payType === 1;

    //   if (isAdmin) return itemObject.total_amount;

    //   if (isToPay) return itemObject.total_amount;

    //   return "";
    // },
  },
  // {
  //   type: "text",
  //   name: "delivery_status",
  //   label: "Charge Weight",
  //   className: "form-control-medlarge-col",
  // },
  // {
  //   type: "text",
  //   name: "tempo_collection",
  //   label: "Charge Weight",
  //   className: "form-control-medlarge-col",
  // },
];

const defaultChallanBiltyOriginalTableItems = [
  {
    type: "text",
    name: "bilty_no",
    label: "Bilty No",
    className: "form-control-medium-col",
  },
  {
    type: "text",
    name: "reference_no",
    label: "Bilty No",
    className: "form-control-medium-col",
  },
  // {
  //   type: "text",
  //   name: "mf_no",
  //   label: "Bilty No",
  //   className: "form-control-medium-col",
  // },
  {
    type: "text",
    name: "bilty_date",
    label: "Bilty Date",
    className: "form-control-medium-col",
    convertFunction: (itemObject) => {
      return formatDate(itemObject.bilty_date);
    },
  },
  {
    type: "text",
    name: "station_from",
    label: "Station From",
    className: "form-control-medlarge-col",
  },
  {
    type: "text",
    name: "station_to",
    label: "Station To",
    className: "form-control-medlarge-col",
  },
  {
    type: "text",
    name: "pay_type_name",
    label: "Pay Type",
    className: "form-control-medium-col",
  },
  {
    type: "text",
    name: "consignor_name",
    label: "Consignor Name",
    className: "form-control-large-col",
  },
  {
    type: "text",
    name: "consignee_name",
    label: "Consignee Name",
    className: "form-control-large-col",
  },
  {
    type: "text",
    name: "no_of_package",
    label: "No Of Package",
    className: "form-control-small-col",
  },
  {
    type: "text",
    name: "charge_weight",
    label: "Charge Weight",
    className: "form-control-small-col",
  },
  {
    type: "text",
    name: "total_amount",
    label: "Charge Weight",
    className: "form-control-small-col",

    convertFunction: (itemObject) => {
      let roleId = 0;

      try {
        roleId = Number(
          JSON.parse(sessionStorage.getItem("role_id"))?.role_id || 0
        );
      } catch (e) {
        roleId = 0;
      }

      const payType = Number(itemObject?.pay_type);

      const isAdmin = roleId === 1 || roleId === 2;
      const isToPay = payType === 1;

      if (isAdmin) return itemObject.total_amount;

      if (isToPay) return itemObject.total_amount;

      return "";
    },
  },
  {
    type: "text",
    name: "delivery_status",
    label: "Charge Weight",
    className: "form-control-medlarge-col",
  },
  {
    type: "text",
    name: "tempo_collection",
    label: "Charge Weight",
    className: "form-control-medlarge-col",
  },
];

const getTableHeaderBasedOnClient = ()=> {
  if (process.env.REACT_APP_CLIENT == "arbuda"){
    return arbudaChallanBiltyOriginalTableHeader
  }
  else {
    return defaultChallanBiltyOriginalTableHeader
  }
}

const getTableItemBasedOnClient = () => {
  if(process.env.REACT_APP_CLIENT == "arbuda"){
    return arbudaChallanBiltyOriginalTableItems
  } 
  else{
    return defaultChallanBiltyOriginalTableItems
  }
}

var challanBiltyOriginalTableHeader  = getTableHeaderBasedOnClient()

var challanBiltyOriginalTableItems  = getTableItemBasedOnClient()

function validate(values) {
  let errors = {};

  function validator(value, regexp) {
    var regex = new RegExp(regexp);
    if (values.hasOwnProperty(value)) {
      if (!values[value].trim()) {
        errors[value] = "Required Field";
      } else if (!regex.test(values[value])) {
        errors[value] = "Validation Error";
      } else {
        errors[value] = "";
      }
    }
  }
  for (let group_name of groupNames) {
    for (let i = 0; i < groupInfo[group_name].length; i++) {
      console.log(groupInfo[group_name][i]);
      let field_object = groupInfo[group_name][i];
      if (field_object.toValidate) {
        validator(field_object.name, field_object.regExpValidation);
      }
    }
  }
  return errors;
}

const popupInfo = {
  success_header: "Marfatiya Saving Successful ",
  error_header: "Error In Marfatiya Module ",
  success_title: "Marfatiya is successfully created with the following info:-",
  field_label_success: "Marfatiya No.",
  field_name_success: "mf_no",
  error_title: "Error in Marfatiya module with the following info:-",
  field_label_error: "Error:",
};

export {
  groupInfo,
  groupNames,
  dataObject,
  validate,
  popupInfo,
  challanBiltyOriginalTableHeader,
  challanBiltyOriginalTableItems,
};
